/**
 * ScrollToTop Component
 * Scrolls window to top on route change
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    // Use scrollTo(0, 0) for immediate scroll without animation
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      // Also scroll the document element for better browser compatibility
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    }
  }, [pathname]);

  return null;
};
